export default __webpack_public_path__ + "static/media/p53.155cfc76.jpg";